import { CanMatchFn } from '@angular/router';
import Swal from 'sweetalert2';

export const authGuard: CanMatchFn = (route, segments) => {
  const menuList = localStorage.getItem('MenuList');
  let UserDetails: any = localStorage.getItem('user_details');
  let UserRoleId: any;
  if (!menuList) {
    alert('You do not have permission to view this page');
    return false;
  }

  if (!UserDetails) {
    alert('You do not have permission to view this page');
    return false;
  }

  if (UserDetails && JSON.parse(UserDetails).userDetail) {
    UserRoleId = JSON.parse(UserDetails).userDetail;
  }

  const parsedMenu = JSON.parse(menuList);
  const url = segments.map(s => s.path).join('/');

  const hasAccessForUserToRoute = parsedMenu.some((item: any) =>
    item.routerUrl === 'admin/' + url &&
    item.roleID === UserRoleId.roleID
  );

  if (!hasAccessForUserToRoute) {
    Swal.fire({
      icon: 'error',
      title: 'Access Denied',
      text: 'You do not have permission to view this page',
    }).then(() => {
      window.history.back();
    });
    return false;
  }

  return hasAccessForUserToRoute;
};


